import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { CookieConsent } from "./components/site/CookieConsent";
import Home from "./pages/Home";
import About from "./pages/About";
import Membership from "./pages/Membership";
import Ecosystem from "./pages/Ecosystem";
import Apply from "./pages/Apply";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import MembershipTerms from "./pages/MembershipTerms";
import NotFound from "./pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/ecosystem" element={<Ecosystem />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/membership-terms" element={<MembershipTerms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
